const initState = {projects: null, selectedProject: null, locations: null, assignments: null}

const projectReducer = (state = initState, action) => {
  switch (action.type) {
    case 'CREATE_PROJECT_SUCCESS':
      console.log('create project success');
      return state;
    case 'CREATE_PROJECT_ERROR':
      console.log('create project error');
      return state;
    case 'PROJECTS_RETRIEVED':
      console.log('projects retrieved');
      return {
        ...state,
        projects: action.projects,
        selectedProject: action.projects[0]
      }
    case 'PROJECT_CHANGED':
      console.log('project changed');
      return {
        ...state,
        
        selectedProject: action.project,
        journals: null,
        locations: null,
        assignments: null
      }
      case 'PROJECT_CREATED':
      console.log('project created');
      
      return {
        ...state,
        
        selectedProject: action.projects[action.projects.length - 1],
        projects: action.projects
      }
    case 'PROJECT_MODAL_OPEN':
      console.log('Setting project dialog state');
      return {
        ...state,
        openProjectModal: action.open
      }
    case 'SIGNUP_SUCCESS':
      console.log('signup success');
      return {
        ...state,
        projects: null
        
      }
      case 'SIGNOUT_SUCCESS':
      console.log('signout success');

      return {
        initState
      }
    case 'LOCATIONS_RETRIEVED':
      console.log('locations retrieved');
      
      var locations = action.locations;
      

      var filteredLocations = action.filteredLocations;
      if ((filteredLocations === null) || (filteredLocations === undefined)) {
        filteredLocations = locations;
      }

      var locationRows = new Array();
      for (var i = 0; i < filteredLocations.length; i++) {
        locationRows.push(false);
      }

      return {
        ...state,
        locationRows: locationRows,
        locations: action.locations,
        filteredLocations: filteredLocations,
        locationsSelectAll: false
      }
    case 'LOCATION_ROW_SELECTED':
      var locationRows = new Array();
      for (var i = 0; i < action.locationRows.length; i++) {
        locationRows.push(action.locationRows[i]);
      }
      return {
        ...state,
        locationRows: locationRows

      }
    case 'LOCATION_ROW_SELECTALL':
      return {
        ...state,
        locationsSelectAll: action.selected
        
      }
      case 'ASSIGNMENTS_RETRIEVED':
      return {
        ...state,
        assignments: action.assignments
      }
    default:
      return state;
  }
};

export default projectReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/projectReducer.js